import axios from "axios";
import { getToken } from "../services/storage.service";
import { ENV } from "../config/env";

const axiosClient = axios.create({
  baseURL: ENV.API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to headers
axiosClient.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle responses / errors globally if needed
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Example: handle 401 globally
    if (error.response?.status === 401) {
      // optionally logout or redirect
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
